import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          throw new Error('No session_id found');
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session_token
        await axios.post(`${API}/auth/session`, 
          { session_id: sessionId },
          { withCredentials: true }
        );

        // Check if user is admin
        try {
          await axios.get(`${API}/admin/me`, { withCredentials: true });
          window.history.replaceState(null, '', '/admin');
          navigate('/admin/dashboard', { replace: true });
        } catch (err) {
          setError('You do not have admin access. Contact a Super Admin to get promoted.');
          setTimeout(() => navigate('/admin/login', { replace: true }), 3000);
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError('Authentication failed. Please try again.');
        setTimeout(() => navigate('/admin/login', { replace: true }), 2000);
      }
    };

    processAuth();
  }, [location, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="text-center max-w-md p-8">
          <p className="text-red-400 mb-4">{error}</p>
          <p className="text-slate-500">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#0077B6] mx-auto mb-4" />
        <p className="text-slate-400">Verifying admin access...</p>
      </div>
    </div>
  );
};

export default AdminAuthCallback;
